var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-1 border-right border-dark text-bold",staticStyle:{"width":"100%","background-color":"rgb(204,255,179)"}},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }